import React, { useState } from 'react';
import { Calendar, Users, Award, TrendingUp, Download, Filter, Search, BarChart } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Input } from '../../components/ui/Input';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/Table';
export function EventsReports() {
  const [selectedPeriod, setSelectedPeriod] = useState('Q1-2025');
  const stats = [{
    label: 'Total Acara',
    value: '24',
    change: '+6',
    icon: Calendar,
    trend: 'up'
  }, {
    label: 'Total Peserta',
    value: '1,245',
    change: '+18.5%',
    icon: Users,
    trend: 'up'
  }, {
    label: 'Sertifikat Terbit',
    value: '892',
    change: '+12.3%',
    icon: Award,
    trend: 'up'
  }, {
    label: 'Tingkat Kehadiran',
    value: '87%',
    change: '+5%',
    icon: TrendingUp,
    trend: 'up'
  }];
  const reports = [{
    id: 1,
    title: 'Laporan Acara Q1 2025',
    period: 'Jan - Mar 2025',
    events: 24,
    participants: 1245,
    status: 'Selesai',
    date: '31 Mar 2025'
  }, {
    id: 2,
    title: 'Laporan Pelatihan Januari 2025',
    period: 'Januari 2025',
    events: 8,
    participants: 420,
    status: 'Selesai',
    date: '31 Jan 2025'
  }, {
    id: 3,
    title: 'Laporan Seminar Februari 2025',
    period: 'Februari 2025',
    events: 6,
    participants: 380,
    status: 'Selesai',
    date: '28 Feb 2025'
  }, {
    id: 4,
    title: 'Laporan Workshop Maret 2025',
    period: 'Maret 2025',
    events: 10,
    participants: 445,
    status: 'Proses',
    date: '31 Mar 2025'
  }, {
    id: 5,
    title: 'Laporan Sertifikasi Q1 2025',
    period: 'Jan - Mar 2025',
    events: 12,
    participants: 892,
    status: 'Proses',
    date: '31 Mar 2025'
  }];
  const topEvents = [{
    name: 'Workshop React Advanced',
    participants: 150,
    satisfaction: 4.8,
    certificates: 145
  }, {
    name: 'Seminar AI & ML 2025',
    participants: 200,
    satisfaction: 4.9,
    certificates: 195
  }, {
    name: 'Bootcamp DevOps',
    participants: 120,
    satisfaction: 4.7,
    certificates: 118
  }];
  return <div className="min-h-screen bg-white" data-id="element-2876">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8" data-id="element-2877">
        {/* Header */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-2878">
          <div data-id="element-2879">
            <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-2880">
              Laporan Acara
            </h1>
            <p className="text-neutral-600" data-id="element-2881">
              Statistik dan laporan acara ATIOS
            </p>
          </div>
          <div className="flex gap-3" data-id="element-2882">
            <Button variant="secondary" data-id="element-2883">
              <Filter className="w-4 h-4 mr-2" data-id="element-2884" />
              Filter
            </Button>
            <Button data-id="element-2885">
              <Download className="w-4 h-4 mr-2" data-id="element-2886" />
              Ekspor Laporan
            </Button>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-2887">
          {stats.map((stat, i) => <Card key={i} data-id="element-2888">
              <CardContent className="p-6" data-id="element-2889">
                <div className="flex items-center justify-between mb-4" data-id="element-2890">
                  <div className="p-3 rounded-lg bg-success-light" data-id="element-2891">
                    <stat.icon className="w-6 h-6 text-success" data-id="element-2892" />
                  </div>
                  <Badge variant="success" className="text-xs" data-id="element-2893">
                    {stat.change}
                  </Badge>
                </div>
                <h3 className="text-2xl font-semibold text-neutral-900 mb-1" data-id="element-2894">
                  {stat.value}
                </h3>
                <p className="text-sm text-neutral-600" data-id="element-2895">{stat.label}</p>
              </CardContent>
            </Card>)}
        </div>

        {/* Top Events */}
        <Card data-id="element-2896">
          <CardHeader data-id="element-2897">
            <CardTitle data-id="element-2898">Acara Terpopuler</CardTitle>
          </CardHeader>
          <CardContent data-id="element-2899">
            <div className="space-y-4" data-id="element-2900">
              {topEvents.map((event, i) => <div key={i} className="flex items-center justify-between p-4 rounded-lg border border-neutral-200" data-id="element-2901">
                  <div className="flex items-center gap-4" data-id="element-2902">
                    <div className="h-12 w-12 rounded-lg bg-atios-light flex items-center justify-center text-atios-primary font-semibold" data-id="element-2903">
                      #{i + 1}
                    </div>
                    <div data-id="element-2904">
                      <h4 className="font-semibold text-neutral-900" data-id="element-2905">
                        {event.name}
                      </h4>
                      <p className="text-sm text-neutral-600" data-id="element-2906">
                        {event.participants} peserta • Rating{' '}
                        {event.satisfaction}/5.0
                      </p>
                    </div>
                  </div>
                  <div className="text-right" data-id="element-2907">
                    <Badge variant="success" data-id="element-2908">
                      {event.certificates} Sertifikat
                    </Badge>
                  </div>
                </div>)}
            </div>
          </CardContent>
        </Card>

        {/* Search & Period */}
        <div className="flex flex-col sm:flex-row gap-4" data-id="element-2909">
          <div className="flex-1 relative" data-id="element-2910">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-neutral-400" data-id="element-2911" />
            <Input placeholder="Cari laporan..." className="pl-10" data-id="element-2912" />
          </div>
          <select value={selectedPeriod} onChange={e => setSelectedPeriod(e.target.value)} className="px-4 py-2 rounded-lg border border-neutral-300 bg-white text-sm text-neutral-900 focus:outline-none focus:ring-2 focus:ring-atios-primary" data-id="element-2913">
            <option value="Q1-2025" data-id="element-2914">Q1 2025</option>
            <option value="Q4-2024" data-id="element-2915">Q4 2024</option>
            <option value="Q3-2024" data-id="element-2916">Q3 2024</option>
          </select>
        </div>

        {/* Reports Table */}
        <Card data-id="element-2917">
          <CardHeader data-id="element-2918">
            <CardTitle data-id="element-2919">Daftar Laporan</CardTitle>
          </CardHeader>
          <CardContent data-id="element-2920">
            <Table data-id="element-2921">
              <TableHeader data-id="element-2922">
                <TableRow data-id="element-2923">
                  <TableHead data-id="element-2924">Judul Laporan</TableHead>
                  <TableHead data-id="element-2925">Periode</TableHead>
                  <TableHead data-id="element-2926">Jumlah Acara</TableHead>
                  <TableHead data-id="element-2927">Total Peserta</TableHead>
                  <TableHead data-id="element-2928">Status</TableHead>
                  <TableHead data-id="element-2929">Tanggal</TableHead>
                  <TableHead className="text-right" data-id="element-2930">Aksi</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody data-id="element-2931">
                {reports.map(report => <TableRow key={report.id} data-id="element-2932">
                    <TableCell className="font-medium text-neutral-900" data-id="element-2933">
                      {report.title}
                    </TableCell>
                    <TableCell className="text-neutral-600" data-id="element-2934">
                      {report.period}
                    </TableCell>
                    <TableCell className="text-neutral-900" data-id="element-2935">
                      {report.events} acara
                    </TableCell>
                    <TableCell className="text-neutral-900" data-id="element-2936">
                      {report.participants.toLocaleString('id-ID')} peserta
                    </TableCell>
                    <TableCell data-id="element-2937">
                      <Badge variant={report.status === 'Selesai' ? 'success' : 'warning'} data-id="element-2938">
                        {report.status}
                      </Badge>
                    </TableCell>
                    <TableCell className="text-neutral-600" data-id="element-2939">
                      {report.date}
                    </TableCell>
                    <TableCell className="text-right" data-id="element-2940">
                      <Button size="sm" variant="secondary" disabled={report.status !== 'Selesai'} data-id="element-2941">
                        <Download className="w-4 h-4 mr-2" data-id="element-2942" />
                        Unduh
                      </Button>
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </CardContent>
        </Card>

        {/* Analytics CTA */}
        <Card className="bg-gradient-to-r from-atios-light to-white border-atios-primary/20" data-id="element-2943">
          <CardContent className="p-8" data-id="element-2944">
            <div className="flex items-center gap-4" data-id="element-2945">
              <div className="h-16 w-16 rounded-lg bg-atios-primary flex items-center justify-center" data-id="element-2946">
                <BarChart className="h-8 w-8 text-white" data-id="element-2947" />
              </div>
              <div className="flex-1" data-id="element-2948">
                <h3 className="text-xl font-semibold text-neutral-900 mb-1" data-id="element-2949">
                  Analitik Mendalam
                </h3>
                <p className="text-neutral-600" data-id="element-2950">
                  Dapatkan insight lebih detail tentang performa acara dengan
                  dashboard analitik
                </p>
              </div>
              <Button size="lg" data-id="element-2951">Lihat Analitik</Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
}